/* global AFRAME */

AFRAME.registerComponent('emit-event', {
  schema: {
    on: {type: 'string'},
    target: {type: 'array', default: []},
    event: {type: 'string'}
  },

  multiple: true,

  init: function () {
    var data = this.data;
    var el = this.el;

    el.addEventListener(data.on, function () {
      for (var i = 0; i < data.target.length; i++) {
        var els = document.querySelectorAll(data.target[i]);
        for(var j = 0; j < els.length; j++) {
          els[j].emit(data.event);
        }
      }
    });
  }
});



// WEBPACK FOOTER //
// ./js/components/emit-event.js